import { arrayOf, shape, string, bool } from "prop-types";

function lazyFunction(f) {
  return function () {
    return f.apply(this, arguments);
  };
}

const lazyLinkShape = lazyFunction(() => linkShape);

export const linkShape = shape({
  comingSoon: bool,
  comingSoonLabel: string,
  href: string, // might not be a link...
  title: string.isRequired,
  target: string,
  children: arrayOf(lazyLinkShape), // lazy for recursion
});

export const navItemShape = shape({
  href: string,
  title: string.isRequired,
  children: arrayOf(lazyLinkShape),
});

export const flyoutNavShape = arrayOf(navItemShape);
